import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询
export function getAllocationConfigList(data) {
  return request({
    url: URL.mdm.automaticAllocationConfig.allocationConfigList,
    method: 'post',
    data
  })
}

// 新增/修改
export function saveAllocationConfig(data) {
  return request({
    url: URL.mdm.automaticAllocationConfig.allocationConfig,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

// 删除
export function delAllocationConfig(data) {
  return request({
    url: URL.mdm.automaticAllocationConfig.allocationConfig,
    method: 'delete',
    data
  })
}
